import { useEffect, useRef } from 'react';
import { useKernel } from './AIKernel';

export const useFrustrationSensor = () => {
    const { reportBehavior } = useKernel();
    
    // useRef persists the array across renders without causing re-renders itself
    const clickTimestamps = useRef([]);

    useEffect(() => {
        const handleGlobalClick = (e) => {
            const now = Date.now();
            clickTimestamps.current.push(now);

            // Filter the array to ONLY keep clicks that happened in the last 1000ms (1 second)
            clickTimestamps.current = clickTimestamps.current.filter(time => now - time < 1000);

            // Threshold: 4 clicks in under 1 second indicates erratic behavior / frustration
            if (clickTimestamps.current.length >= 4) {
                // 1. Report the behavior to the Agent's Memory Matrix
                reportBehavior('rageClicks', 1, 'behavior');
                
                // 2. Clear the array immediately so it doesn't spam the memory matrix 
                // if they keep furiously clicking
                clickTimestamps.current = [];
                
                // Debugging log so you can see the AI catching the behavior in your console
                console.log("⚡ [Agent Sensor] Frustration spike detected. Agent updating cognitive load variables.");
            }
        };

        // Attach a passive event listener to the highest level of the DOM
        window.addEventListener('click', handleGlobalClick, { passive: true });

        // Cleanup function prevents memory leaks when the app unmounts
        return () => {
            window.removeEventListener('click', handleGlobalClick);
        };
    }, [reportBehavior]);
};